import {
	DocumentMappingsResponse,
	DocumentTemplate,
	DocumentTemplateType,
} from "@dune/types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axios";

export const useGetDocumentMappings = () =>
	useQuery<DocumentMappingsResponse>({
		queryKey: ["documentMappings"],
		queryFn: async () => {
			const { data } = await privateAxios.get("/documents/mappings");
			return data;
		},
	});

export const useGetDocumentTemplates = () =>
	useQuery<DocumentTemplate[]>({
		queryKey: ["documentTemplates"],
		queryFn: async () => {
			const response = await privateAxios.get("/documents/templates/latest");
			return response.data;
		},
	});

/**
 * Fetch available entity models from backend mappings
 */
export const useGetEntityModels = () =>
	useQuery<string[]>({
		queryKey: ["entityModels"],
		queryFn: async () => {
			const response = await privateAxios.get<DocumentMappingsResponse>(
				"/documents/mappings",
			);
			return Object.keys(response.data.documentMappings);
		},
	});

/**
 * Fetch available template types
 */
export const useGetTemplateTypes = () =>
	useQuery<string[]>({
		queryKey: ["templateTypes"],
		queryFn: async () => {
			return Object.values(DocumentTemplateType);
		},
	});

/**
 * Fetch template types allowed for a specific entity model
 */
export const useGetTemplateTypesForEntity = (entityModel: string) =>
	useQuery<string[]>({
		queryKey: ["templateTypesForEntity", entityModel],
		queryFn: async () => {
			if (!entityModel) {
				return [];
			}
			const response = await privateAxios.get<string[]>(
				`/documents/template-types/${entityModel}`,
			);
			return response.data;
		},
		enabled: !!entityModel,
	});
